/* AILCBI Theme JS — progressive enhancement, no dependencies */
(function () {
  'use strict';

  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  /* ---------- load state (hero reveal) ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () { document.body.classList.add('is-loaded'); }, 60);
  });

  /* ---------- header glass on scroll ---------- */
  var header = document.querySelector('.site-header');
  function onScrollHeader() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 40);
  }
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  /* ---------- mobile menu ---------- */
  var burger = document.querySelector('[data-burger]');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
      header.classList.toggle('menu-open');
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobileMenu.classList.remove('open'); header.classList.remove('menu-open'); });
    });
  }

  /* ---------- reveal on scroll ---------- */
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); revealObserver.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { revealObserver.observe(el); });

  /* ---------- hero device mouse tilt ---------- */
  var hero = document.querySelector('.hero');
  var heroDevice = document.querySelector('.hero__device-inner');
  if (hero && heroDevice && window.matchMedia('(pointer: fine)').matches) {
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      heroDevice.style.transform = 'rotateY(' + x * 16 + 'deg) rotateX(' + -y * 10 + 'deg)';
    });
  }

  /* ---------- mode toggles ---------- */
  document.querySelectorAll('[data-mode-switch]').forEach(function (group) {
    var device = group.querySelector('.device') || document.querySelector(group.getAttribute('data-mode-switch'));
    group.querySelectorAll('[data-mode-target]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-mode-target');
        var scope = btn.closest('section') || document;
        scope.querySelectorAll('.device').forEach(function (d) { d.setAttribute('data-mode', target); });
        group.querySelectorAll('[data-mode-target]').forEach(function (b) { b.classList.toggle('active', b === btn); });
        var card = scope.querySelector('[data-mode-card]');
        if (card) {
          var m = btn.getAttribute('data-mode-title');
          var s = btn.getAttribute('data-mode-spec');
          var d = btn.getAttribute('data-mode-desc');
          var c = btn.getAttribute('data-mode-color');
          card.querySelector('.tech__spec').textContent = s;
          card.querySelector('.tech__spec').style.color = c;
          card.querySelector('h3').textContent = m;
          card.querySelector('p').textContent = d;
        }
      });
    });
  });

  /* ---------- viewer: drag rotate + zoom + hotspots ---------- */
  var vDevice = document.querySelector('.viewer__device');
  if (vDevice) {
    var rot = 0, zoom = 1, dragging = false, lastX = 0;
    function apply() {
      vDevice.style.transform = 'rotateY(' + rot + 'deg) scale(' + zoom + ')';
    }
    vDevice.addEventListener('pointerdown', function (e) { dragging = true; lastX = e.clientX; });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      rot = Math.max(-35, Math.min(35, rot + (e.clientX - lastX) * 0.25));
      lastX = e.clientX;
      apply();
    });
    window.addEventListener('pointerup', function () { dragging = false; });
    var stage = vDevice.closest('.viewer__stage');
    document.querySelectorAll('[data-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        zoom = b.getAttribute('data-zoom') === 'in' ? Math.min(1.6, zoom + 0.15) : Math.max(0.8, zoom - 0.15);
        apply();
      });
    });
    var resetBtn = document.querySelector('[data-rotate-reset]');
    if (resetBtn) resetBtn.addEventListener('click', function () { rot = 0; zoom = 1; apply(); });

    var tooltip = stage ? stage.querySelector('.viewer__tooltip') : null;
    function showHotspot(id, el) {
      var data = window.__hotspots && window.__hotspots[id];
      if (!data || !tooltip) return;
      tooltip.querySelector('h4').textContent = data.label;
      tooltip.querySelector('p').textContent = data.desc;
      tooltip.style.display = 'block';
      document.querySelectorAll('.viewer__list button').forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-hotspot') === id);
      });
    }
    document.querySelectorAll('.hotspot').forEach(function (h) {
      h.addEventListener('click', function () { showHotspot(h.getAttribute('data-hotspot'), h); });
    });
    document.querySelectorAll('.viewer__list button').forEach(function (b) {
      b.addEventListener('click', function () { showHotspot(b.getAttribute('data-hotspot'), b); });
    });
  }

  /* ---------- scroll experience ---------- */
  var scrollex = document.querySelector('.scrollex');
  if (scrollex && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var sDevice = scrollex.querySelector('.scrollex__device');
    var sDeviceInner = scrollex.querySelector('.device');
    var sticky = scrollex.querySelector('.scrollex__sticky');
    var callouts = scrollex.querySelectorAll('.scrollex__callout');
    var ranges = [[0.08, 0.32], [0.38, 0.62], [0.68, 0.92]];
    function lerp(a, b, t) { return a + (b - a) * t; }
    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
    function fade(p, r) {
      if (p < r[0] || p > r[1]) return 0;
      var fi = clamp((p - r[0]) / 0.06, 0, 1);
      var fo = clamp((r[1] - p) / 0.06, 0, 1);
      return Math.min(fi, fo);
    }
    function onScroll() {
      var rect = scrollex.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var p = clamp(-rect.top / total, 0, 1);
      if (sDevice) {
        var ry = p < 0.5 ? lerp(-24, 24, p * 2) : lerp(24, -12, (p - 0.5) * 2);
        var sc = p < 0.5 ? lerp(0.85, 1.12, p * 2) : lerp(1.12, 0.95, (p - 0.5) * 2);
        sDevice.style.transform = 'rotateY(' + ry + 'deg) scale(' + sc + ')';
      }
      if (sDeviceInner) sDeviceInner.setAttribute('data-mode', p > 0.34 && p < 0.66 ? 'blue' : 'red');
      if (sticky) {
        var r = Math.round(lerp(5, 11, Math.sin(p * Math.PI)));
        var b2 = Math.round(lerp(5, 20, Math.sin(p * Math.PI)));
        sticky.style.backgroundColor = 'rgb(' + r + ',' + r + ',' + b2 + ')';
      }
      callouts.forEach(function (c, i) {
        var o = fade(p, ranges[i % ranges.length]);
        c.style.opacity = o;
        c.style.transform = 'translateX(' + (1 - o) * 24 + 'px)';
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- accordions (faq + tabs) ---------- */
  document.querySelectorAll('[data-accordion-head]').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.parentElement;
      var body = item.querySelector('[data-accordion-body]');
      var open = item.classList.toggle('open');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
      if (item.hasAttribute('data-exclusive')) {
        item.parentElement.querySelectorAll('.open').forEach(function (o) {
          if (o !== item) { o.classList.remove('open'); o.querySelector('[data-accordion-body]').style.maxHeight = '0px'; }
        });
      }
    });
  });

  /* ---------- reviews carousel ---------- */
  var reviewRoot = document.querySelector('[data-reviews]');
  if (reviewRoot) {
    var reviews = window.__reviews || [];
    var idx = 0;
    var card = reviewRoot.querySelector('.review-card');
    function render() {
      var r = reviews[idx];
      if (!r) return;
      card.querySelector('h3').textContent = '\u201C' + r.title + '\u201D';
      card.querySelector('.body').textContent = r.text;
      card.querySelector('.name').textContent = r.name;
      var img = card.querySelector('.review-card__author img');
      if (img && r.avatar) img.src = r.avatar;
      reviewRoot.querySelectorAll('.reviews__tabs button').forEach(function (b, i) {
        b.classList.toggle('active', i === idx);
      });
    }
    reviewRoot.querySelector('[data-review-prev]').addEventListener('click', function () { idx = (idx - 1 + reviews.length) % reviews.length; render(); });
    reviewRoot.querySelector('[data-review-next]').addEventListener('click', function () { idx = (idx + 1) % reviews.length; render(); });
    reviewRoot.querySelectorAll('.reviews__tabs button').forEach(function (b, i) {
      b.addEventListener('click', function () { idx = i; render(); });
    });
  }

  /* ---------- buy gallery thumbs ---------- */
  document.querySelectorAll('.buy__thumbs button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var stage = document.querySelector('.buy__stage');
      var src = btn.getAttribute('data-full');
      stage.querySelectorAll('.buy__main').forEach(function (m) { m.style.display = 'none'; });
      var target = stage.querySelector('[data-main="' + src + '"]');
      if (target) target.style.display = 'flex';
      btn.parentElement.querySelectorAll('button').forEach(function (b) { b.classList.toggle('active', b === btn); });
    });
  });

  /* ---------- quantity selectors ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var span = q.querySelector('[data-qty-value]');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(span.textContent, 10) + (b.hasAttribute('data-qty-plus') ? 1 : -1);
        span.textContent = Math.max(1, v);
      });
    });
  });

  /* ---------- cart ---------- */
  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-overlay');
  function openCart() { if (drawer) { drawer.classList.add('open'); overlay.classList.add('open'); } }
  function closeCart() { if (drawer) { drawer.classList.remove('open'); overlay.classList.remove('open'); } }
  document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.addEventListener('click', openCart); });
  document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  if (overlay) overlay.addEventListener('click', closeCart);

  function deviceThumb() {
    var tpl = document.getElementById('device-thumb-template');
    return tpl ? tpl.innerHTML : '';
  }

  function renderCart(cart) {
    var body = drawer.querySelector('.cart-drawer__body');
    var foot = drawer.querySelector('.cart-drawer__foot');
    var counts = document.querySelectorAll('.cart-count');
    counts.forEach(function (c) {
      c.textContent = cart.item_count;
      c.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p></div>';
      foot.style.display = 'none';
      return;
    }
    foot.style.display = 'block';
    body.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="">'
        : '<div class="device" data-mode="red">' + deviceThumb() + '</div>';
      return '<div class="cart-item" data-line-key="' + item.key + '">' +
        '<div class="cart-item__img">' + img + '</div>' +
        '<div class="cart-item__info">' +
        '<p class="name">' + item.product_title + '</p>' +
        '<p class="price">' + formatMoney(item.price) + '</p>' +
        '<div class="qty" data-cart-qty>' +
        '<button data-cart-minus aria-label="Decrease">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button data-cart-plus aria-label="Increase">+</button>' +
        '</div></div>' +
        '<p class="cart-item__total">' + formatMoney(item.final_line_price) + '</p>' +
        '</div>';
    }).join('');
    drawer.querySelector('[data-cart-subtotal]').textContent = formatMoney(cart.total_price);
    body.querySelectorAll('.cart-item').forEach(function (row) {
      var key = row.getAttribute('data-line-key');
      row.querySelector('[data-cart-minus]').addEventListener('click', function () {
        changeLine(key, parseInt(row.querySelector('[data-cart-qty] span').textContent, 10) - 1);
      });
      row.querySelector('[data-cart-plus]').addEventListener('click', function () {
        changeLine(key, parseInt(row.querySelector('[data-cart-qty] span').textContent, 10) + 1);
      });
    });
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }
  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('[data-product-form]') || document;
      var variantId = form.querySelector('[data-variant-id]');
      var qtyEl = form.querySelector('[data-qty-value]');
      if (!variantId || !variantId.value) { window.location.href = '/cart'; return; }
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId.value, 10), quantity: qtyEl ? parseInt(qtyEl.textContent, 10) : 1 }] })
      }).then(function () { return refreshCart(); }).then(function () {
        btn.disabled = false;
        openCart();
        if (btn.hasAttribute('data-buy-now')) window.location.href = '/checkout';
      }).catch(function () { btn.disabled = false; });
    });
  });
  if (drawer) refreshCart();

  /* ---------- sticky atc ---------- */
  var sticky = document.querySelector('.sticky-atc');
  var shopSection = document.getElementById('shop');
  if (sticky && shopSection) {
    window.addEventListener('scroll', function () {
      sticky.classList.toggle('show', window.scrollY > shopSection.offsetTop - window.innerHeight);
    }, { passive: true });
  }
})();
